export default {"src":"/_next/static/media/AUFlag.da3ac393.svg","height":24,"width":32};